import React, { useState, useEffect, useRef } from 'react';
import clickSound from '../Audios/click.mp3'; // Asegúrate de tener un archivo de sonido en tu proyecto

const RandomNumberGenerator = () => {
  const [lowerLimit, setLowerLimit] = useState(1);
  const [upperLimit, setUpperLimit] = useState(100);
  const [speed, setSpeed] = useState(1000); // en milisegundos
  const [count, setCount] = useState(10); // cantidad de veces
  const [currentNumber, setCurrentNumber] = useState(null);
  const [sum, setSum] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [showSum, setShowSum] = useState(false); // Controla si se muestra la suma
  const intervalRef = useRef(null);
  const audioRef = useRef(new Audio(clickSound)); // Referencia al audio

  const generateRandomNumber = () => {
    return Math.floor(Math.random() * (upperLimit - lowerLimit + 1)) + lowerLimit;
  };
  const showResult = () => {
    setShowSum(true);
    setShowSum(true); // Muestra la suma al finalizar
  };

  const startGame = () => {
    if (isRunning) return;
    setIsRunning(true);
    setShowSum(false); // Oculta la suma al iniciar
    setSum(0);
    let counter = 0;

    intervalRef.current = setInterval(() => {
      if (counter < count) {
        const randomNum = generateRandomNumber();
        setCurrentNumber(randomNum);
        setSum(prevSum => prevSum + randomNum);
        audioRef.current.play(); // Reproduce el sonido
        counter++;
      } else {
        clearInterval(intervalRef.current);
        setIsRunning(false);
        
      }
    }, speed);
  };

  const resetGame = () => {
    clearInterval(intervalRef.current);
    setIsRunning(false);
    setCurrentNumber(null);
    setSum(0);
    setShowSum(false); // Oculta la suma al resetear
  };

  useEffect(() => {
    return () => clearInterval(intervalRef.current); // Limpiar el intervalo al desmontar
  }, []);

  return (
    <div style={styles.mainContainer}>
      <div style={styles.leftContainer}>
        <h1 style={styles.title}>Juego Mental de Ábaco</h1>
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Límite Inferior:
            <input
              type="number"
              value={lowerLimit}
              onChange={(e) => setLowerLimit(Number(e.target.value))}
              style={styles.input}
            />
          </label>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Límite Superior:
            <input
              type="number"
              value={upperLimit}
              onChange={(e) => setUpperLimit(Number(e.target.value))}
              style={styles.input}
            />
          </label>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Velocidad (ms):
            <input
              type="number"
              value={speed}
              min="1"
              onChange={(e) => setSpeed(Math.max(1, Number(e.target.value)))}
              style={styles.input}
            />
          </label>
        </div>
        <div style={styles.inputGroup}>
          <label style={styles.label}>
            Cantidad de veces:
            <input
              type="number"
              value={count}
              min="1"
              onChange={(e) => setCount(Math.max(1, Number(e.target.value)))}
              style={styles.input}
            />
          </label>
        </div>
      </div>

      <div style={styles.rightContainer}>
        <div style={styles.buttonGroup}>
          <button onClick={startGame} disabled={isRunning} style={styles.button}>
            Iniciar Partida
          </button>
          <button onClick={resetGame} style={styles.button}>
            Resetear
          </button>
          <button 
            onClick={showResult} 
            disabled={isRunning || sum === 0}
            style={styles.resultButton}
          >
            Resultado
          </button>
        </div>
        
        <div style={styles.numberDisplay}>
          <label style={styles.numberLabel}>Número Actual:</label>
          <div style={styles.numberBox}>
            {currentNumber !== null ? currentNumber : "-"}
          </div>
        </div>

        {showSum && (
          <div style={styles.sumDisplay}>
            <label style={styles.sumLabel}>Suma Total:</label>
            <div style={styles.sumBox}>{sum}</div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    backgroundColor: '#f0f0f0',
    borderRadius: '10px',
    maxWidth: '800px',
    margin: '0 auto',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  leftContainer: {
    flex: 1,
    marginRight: '30px',
  },
  rightContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontSize: '24px',
    color: '#333',
    marginBottom: '20px',
    textAlign: 'center',
  },
  inputGroup: {
    marginBottom: '15px',
  },
  label: {
    fontSize: '16px',
    color: '#555',
    display: 'block',
    marginBottom: '5px',
  },
  input: {
    padding: '8px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '100%',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginBottom: '20px',
    width: '100%',
  },
  button: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#28a745',
    color: '#fff',
    cursor: 'pointer',
    width: '100%',
  },
  resultButton: {
    padding: '12px',
    fontSize: '16px',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    cursor: 'pointer',
    width: '100%',
  },
  numberDisplay: {
    width: '100%',
    textAlign: 'center',
    margin: '20px 0',
  },
  numberLabel: {
    fontSize: '20px',
    color: '#333',
    marginBottom: '10px',
    display: 'block',
  },
  numberBox: {
    fontSize: '40px',
    fontWeight: 'bold',
    color: '#d9534f',
    border: '3px solid #333',
    borderRadius: '10px',
    padding: '15px',
    minWidth: '120px',
    backgroundColor: '#fff',
  },
  sumDisplay: {
    width: '100%',
    textAlign: 'center',
    marginTop: '20px',
  },
  sumLabel: {
    fontSize: '20px',
    color: '#333',
    marginBottom: '10px',
    display: 'block',
  },
  sumBox: {
    fontSize: '32px',
    fontWeight: 'bold',
    color: '#5cb85c',
    border: '2px solid #333',
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#fff',
  },
};

export default RandomNumberGenerator;
